import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {FilterButton} from '@macmillanplatform/ui-core';

import {USER_FIELDS} from '@/features/auth/constants';

import {clearAuthSession} from '@/features/auth/helpers';
import {useAppDispatch} from '@/hooks';

import {fetchUser, selectUserField} from '@/features/auth/slice';

import './index.css';

const UserInfoHeader = () => {
  const accountNumber = useSelector(selectUserField(USER_FIELDS.LINK_ACCOUNT));
  const zipCode = useSelector(selectUserField(USER_FIELDS.ZIP_CODE));

  const dispatch = useAppDispatch();

  const handleLogout = useCallback(() => {
    clearAuthSession();
    dispatch(fetchUser());
  }, [dispatch]);

  return (
    <div className="Product__header-right">
      <div className="Product__header-user-info">
        <span>
          Bill To: <b>{accountNumber}</b>
        </span>
        <span>
          Zip Code: <b>{zipCode}</b>
        </span>
      </div>
      <FilterButton
        className="Product__header-switch-account-button"
        tooltipTitle="Switch Account"
        onClick={handleLogout}
        iconClassName="fa-solid fa-right-from-bracket"
      />
    </div>
  );
};

export default UserInfoHeader;
